export const LIGAS_NACIONALES = Number(9);
export const COPAS_NACIONALES = Number(10);
export const INTERNACIONALES = Number(11);